import { Component, DestroyRef, inject, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { AuthenticationService } from '../authentication/authentication.service';
import { AuthenticationStore } from '../authentication/authentication.store';
import { User } from '../authentication/user.model';
import { UserService } from '../authentication/user.service';
import { ConfirmationService } from '../confirmation/confirmation.service';
import { NotificationService } from '../notification/notification.service';

@Component({
    selector: 'lib-profile',
    templateUrl: './profile.component.html',
    styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit {
    private destroyRef = inject(DestroyRef);

    /** Classe CSS sur le conteneur principal */
    @Input() containerClass = '';

    /** Utilisateur courant */
    user: User;

    /** Mail en mode édition ? */
    editMailMode = false;

    /** Email de référence (pour tracer s'il a été modifié) */
    mailRef: string;

    constructor(
        private authenticationService: AuthenticationService,
        private authenticationStore: AuthenticationStore,
        private userService: UserService,
        private notificationService: NotificationService,
        private confirmationService: ConfirmationService,
        private router: Router,
    ) {}

    ngOnInit() {
        this.authenticationStore
            .getCurrentUser()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((user) => {
                if (!user) {
                    return;
                }
                this.user = user;
                this.mailRef = user.email;
            });
    }

    save() {
        if (this.hasMailChanged()) {
            this.confirmationService.confirm(
                'Confirmez-vous la nouvelle adresse email "' +
                    this.user.email +
                    '" ?<br/>' +
                    'Attention : celle-ci sera désormais utilisée pour vous authentifier.',
                () => this.doSave(),
            );
        } else {
            this.doSave();
        }
    }

    editMail() {
        this.confirmationService.confirm(
            'Êtes-vous sûr de vouloir modifier votre adresse email ?<br/>Celle-ci est utilisée pour vous authentifier.',
            () => (this.editMailMode = true),
        );
    }

    private doSave() {
        this.editMailMode = false;
        this.userService.updateAccount(this.user).subscribe(() => {
            if (this.hasMailChanged()) {
                this.notificationService.success(
                    'Le profil a bien été mis à jour. ' + 'Veuillez vous identifier à nouveau avec votre nouvelle adresse mail : ' + this.user.email,
                );
                this.authenticationService.logout().subscribe();
                this.router.navigate(['/login']);
            } else {
                this.notificationService.success('Le profil a bien été mis à jour');
            }
        });
    }

    private hasMailChanged() {
        return this.mailRef !== this.user.email;
    }
}
